export const updateTitle = title => {
  if (typeof window !== "undefined") {
    document.title = buildTitle(title);
  }
};

export const buildTitle = title => {
  const titleParts = [];
  if (title) {
    titleParts.push(title);
  }
  titleParts.push("Humanitix");
  return titleParts.join(" | ");
};

export const getSize = () => {
  let innerWidth = 1000;
  let innerHeight = 1000;
  if (typeof window !== "undefined") {
    innerWidth = window.innerWidth;
    innerHeight = window.innerHeight;
  }
  return {
    innerWidth,
    innerHeight
  };
};

export const camelize = string => {
  let str = string;
  str = str.replace("&", "And");
  str = str.replace(/\s/g, "");
  return str.charAt(0).toLowerCase() + str.slice(1);
};

export const normalizeName = string => {
  let str = string;
  str = str.replace("-", " ");
  let splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
};
